Updates the dates associated with an uploaded candidate profile.
